import React from 'react';
import { Popup } from 'semantic-ui-react';


var MerchantPopup = function (_a) {
    var merchant = _a.merchant, description = _a.description;
    var cnpj = merchant.cnpj, name = merchant.name, cnae = merchant.cnae, businessName = merchant.businessName, category = merchant.category;
    return (React.createElement(Popup, { className: 'MerchantPopup', content: React.createElement(React.Fragment, null,
            cnpj && (React.createElement("p", null,
                React.createElement("strong", null, "CNPJ:"),
                " ",
                cnpj)),
            name && (React.createElement("p", null,
                React.createElement("strong", null, "Nome:"),
                " ",
                name)),
            businessName && (React.createElement("p", null,
                React.createElement("strong", null, "Nome da empresa:"),
                " ",
                businessName)),
            cnae && (React.createElement("p", null,
                React.createElement("strong", null, "CNAE:"),
                " ",
                cnae)),
            category && (React.createElement("p", null,
                React.createElement("strong", null, "Categoria:"),
                " ",
                category))), hoverable: true, trigger: React.createElement("span", { className: 'transaction-description-hoverable' }, description), wide: "very" }));
};
export default React.memo(MerchantPopup);
